/**
 * View Transition API helper for smooth native animations
 * Falls back gracefully on browsers that don't support it
 */

export const handleViewTransition = (cb: () => void) => {
    if (!document.startViewTransition) {
        // Browser doesn't support View Transitions - execute immediately
        cb()
        return
    }

    // Use native View Transition API for smooth animation
    document.startViewTransition(() => cb())
}
